export default "__VITE_ASSET__Cg2NG0tR__"